// extracted by mini-css-extract-plugin
export default {"helperTextContainer":"HelperHeader_helperTextContainer__vMTjq"};